import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import { backgroundTheme } from "./backgroundTheme";
import { whiteTheme } from "./whiteTheme";

const TSThemeProvider = ({ defaultTheme = "light", children }) => {
  const theme = defaultTheme === "background" ? backgroundTheme : whiteTheme;
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export { TSThemeProvider };
